import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AuthGate from './AuthGate';
import Holoscreen from './Holoscreen';
import { installApiAuth } from './apiAuth';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Holoscreen: a set-and-forget, associate-facing rate board for a signage thin
// client. Rendered OUTSIDE the Cognito AuthGate so a device with no interactive
// login can load it (device is authorized by the EWOK-style ServiceProxy /
// signage layer, per builder-security — the operator console's gate is
// unchanged, and the board shows only a narrow non-sensitive OLM1 rate slice).
// Activated by ?holoscreen=1 (e.g. .../?holoscreen=1&site=OLM1).
const isHoloscreen = new URLSearchParams(window.location.search).get('holoscreen') === '1';

if (isHoloscreen) {
  root.render(<Holoscreen />);
} else {
  // Every JarJar API call from the signed-in app carries the Cognito ID token.
  installApiAuth();
  root.render(<AuthGate><App /></AuthGate>);
}
